import { Component, input } from '@angular/core';

@Component({
  selector: 'gs-value-card',
  templateUrl: './gs-value-card.html',
  styleUrl: './gs-value-card.scss',
})
export class GsValueCard {
  tabId = input.required<string>();
  accent = input.required<string>();
  titleRest = input.required<string>();
  body = input<string[]>([]);
}
